import { MapBounds } from './map_interfaces'
import { MarkerClusterer } from '@googlemaps/markerclusterer'
import { waitFor } from './time'

export function waitForMap(mapElement: HTMLElement): Promise<void> {
  return waitFor(() => (mapElement as any).innerMap)
}

export function boundsToUrlParams(bounds: google.maps.LatLngBounds): MapBounds {
  const ne = bounds.getNorthEast()
  const sw = bounds.getSouthWest()

  return {
    ne_lat: ne.lat(),
    ne_lng: ne.lng(),
    sw_lat: sw.lat(),
    sw_lng: sw.lng()
  }
}

export function createBoundsFromParams(params: MapBounds): google.maps.LatLngBounds {
  return new google.maps.LatLngBounds(
    { lat: params.sw_lat, lng: params.sw_lng },
    { lat: params.ne_lat, lng: params.ne_lng }
  )
}

export function updateUrlWithBounds(bounds: MapBounds) {
  const currentUrl = new URL(window.location.href)
  Object.entries(bounds).forEach(([key, value]) => {
    currentUrl.searchParams.set(key, value.toString())
  })
  window.history.replaceState({}, '', currentUrl.toString())
}

export function initializeMarkerClusterer(map: google.maps.Map, options?: any) {
  return new MarkerClusterer({
    map,
    markers: [],
    algorithmOptions: {
      maxZoom: 10,
      ...options?.algorithmOptions
    },
    renderer: {
      render: ({ count, position }) => {
        return createClusterMarker(position, count)
      }
    }
  })
}

export function createClusterMarker(position: google.maps.LatLng, count: number): google.maps.Marker {
  return new google.maps.Marker({
    position,
    icon: {
      url: `data:image/svg+xml;base64,${btoa(`
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="20" cy="20" r="20" fill="#287379" fill-opacity="0.9"/>
        </svg>
      `)}`,
      scaledSize: new google.maps.Size(30, 30),
      anchor: new google.maps.Point(15, 15),
      labelOrigin: new google.maps.Point(15, 15)
    },
    label: {
      text: String(count),
      color: 'white',
      fontSize: '12px',
      fontWeight: 'bold',
      fontFamily: 'Poppins, sans-serif'
    }
  })
}